import React, { useEffect, Fragment, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import * as AgentsActions from 'store/modules/agents/actions';
import * as AgentsSelectors from 'store/modules/agents/selectors';

import { SearchArea } from './Dashboard.styles';
import { ContentShowCards } from 'containers/ContentMarketing/ContentShowCards';
import qs from 'qs';
import SearchBar from 'containers/SearchBar';
import { useDynamicParameters } from 'context/DynamicParameters/DynamicParametersContext';

export const Dashboard = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { dynamicParameters } = useDynamicParameters();
  const selectedCompany = useSelector(AgentsSelectors.selectedCompanySelector);
  const selectedTa = useSelector(AgentsSelectors.selectedTaSelector);

  const handleSearchButtonClick = useCallback(
    searchQuery => {
      const queryWithCompanyTa = {
        ...searchQuery,
        ...(selectedCompany?.uuid && { companyUuid: selectedCompany.uuid }),
        ...(selectedTa?.uuid && { tauuid: selectedTa.uuid }),
      };
      history.push(`/search/beta/?${qs.stringify(queryWithCompanyTa)}`);
    },
    [history, selectedCompany, selectedTa]
  );

  useEffect(() => {
    // when we mount the dashboard, if we already have a selected TA its because we've chosen one
    // before, and then returned to this page. if that's the case, we reload the memberships so they're correct
    // as the user _may_ have altered the memberships by changing TCs via the booking builder search bar
    if (selectedTa) {
      dispatch(AgentsActions.getMembershipsRequestAction(selectedTa.companyUuid, false));
    }
  }, []);

  return (
    <Fragment>
      <SearchArea>
        <div className="container mx-auto max-w-1280px">
          <div className="search-bar-container p-5 max-w-1190px" style={{ backgroundColor: 'rgba(248,248,248,0.85)' }}>
            <SearchBar onSearch={handleSearchButtonClick} />
          </div>
        </div>
      </SearchArea>
      {dynamicParameters.ENABLE_MARKETING_WORKSPACE_TEMP && <ContentShowCards />}
    </Fragment>
  );
};

export default Dashboard;
